import * as React from 'react'
import { useSnapshot } from 'valtio'
import { dataState } from '../../../../store/dataState.ts'
import { Rate } from './Rate.tsx'

interface Props {
    selected: string
    onChange: (i: string) => void
}

export const SelectRate: React.FC<Props> = (props) => {
    const {selected, onChange} = props
    const rates = (useSnapshot(dataState) as typeof dataState).rates
        .filter(r => r.checkInRateType === 'localRate')
        .sort((a, b) => Number(a.seconds) < Number(b.seconds) ? -11 : 1)

    return (
        <div className={'grid grid-cols-3 gap-2 p-4'}>
            {rates.map(r => <Rate key={r._id} rate={r} selected={String(selected) === String(r.seconds)} onClick={onChange}/>)}
        </div>
    )
}
